import CodeLine from "../CodeLine/CodeLine";
import "./About.scss";

export default function HighSchool() {
  const wordsList = [
    { words: [{ text: "{", class: "json-carac" }] },
    {
      words: [
        {
          text: "diploma:",
          list: [
            {
              text: '"Professional Master in Software Engineering - open source"',
              class: "json-value",
            },
            {
              text: ",",
              class: "json-carac",
            },
          ],
          class: "json-key",
        },
      ],
    },
    {
      words: [
        {
          text: "institute:",
          list: [
            {
              text: '"Higher computer Institute of Ariana, Tunisie."',
              class: "json-value",
            },
            {
              text: ",",
              class: "json-carac",
            },
          ],
          class: "json-key",
        },
      ],
    },
    {
      words: [
        {
          text: "graduationYear:",
          list: [
            { text: '"2024"', class: "json-value" },
            { text: ",", class: "json-carac" },
          ],
          class: "json-key",
        },
      ],
    },
    {
      words: [
        {
          text: "duration:",
          list: [
            { text: '"2 years"', class: "json-value" },
            { text: ",", class: "json-carac" },
          ],
          class: "json-key",
        },
      ],
    },
    { words: [{ text: "},", class: "json-carac" }] },
    { words: [{ text: "", class: "" }] },
    { words: [{ text: "{", class: "json-carac" }] },
    {
      words: [
        {
          text: "diploma:",
          class: "json-key",
          list: [
            {
              text: '"National License in Information Technology"',
              class: "json-value",
            },
            { text: ",", class: "json-carac" },
          ],
        },
      ],
    },
    {
      words: [
        {
          text: "institute:",
          list: [
            {
              text: '"Higher Institute for Technological Studies of Beja, Tunisie."',
              class: "json-value",
            },
            {
              text: ",",
              class: "json-carac",
            },
          ],
          class: "json-key",
        },
      ],
    },
    {
      words: [
        {
          text: "graduationYear:",
          list: [
            { text: '"2022"', class: "json-value" },
            { text: ",", class: "json-carac" },
          ],
          class: "json-key",
        },
      ],
    },
    {
      words: [
        {
          text: "duration:",
          list: [
            { text: '"3 years"', class: "json-value" },
            { text: ",", class: "json-carac" },
          ],
          class: "json-key",
        },
      ],
    },
    { words: [{ text: "},", class: "json-carac" }] },
  ];
  return (
    <div className="high-school-layout">
      <div className="high-school-layout__desktop">
        {wordsList.map((w, key) => (
          <CodeLine key={key} lineNumber={key + 1} words={w.words} />
        ))}
      </div>
      <div className="high-school-layout__mobile">
        {`diploma: "Professional Master in Software Engineering - open source",
          institute: "Higher computer Institute of Ariana, Tunisie.",
          graduationYear: "2024",
          duration: "2 years",

          diploma: "National License in Information Technology",
          institute: "Higher Institute for Technological Studies of Beja, Tunisie.",
          graduationYear: "2022",
          duration: "3 years",
        `}
      </div>
    </div>
  );
}
